import {PropsWithChildren} from 'react';

import {Dialog, DialogContent, SwipeableDrawer, useMediaQuery, useTheme, Box} from '@mui/material';

type ResponsivePromptProps = PropsWithChildren<{
  open: boolean;
  onClose: () => void;
}>;

export const ResponsivePrompt: React.FC<ResponsivePromptProps> = ({open, onClose, children}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        onOpen={() => {
          return;
        }}
        disableDiscovery
      >
        <Box p={2}>{children}</Box>
      </SwipeableDrawer>
    );
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
